import parlorDetailType from "@/types/parlorDetailType";
import { get } from "@/utils/api";
import { optimizeParlorDetail } from "@/utils/optimizeDetail";
import { parlorDetailErrorState } from "@/atoms/parlors/detailState";
import { useCallback, useState } from "react";
import { useRecoilState } from "recoil";

function useParlorDetail({ parlorId, type }: { parlorId?: string; type: string }) {
  const [detail, setDetail] = useState<parlorDetailType | undefined>();
  const [isError, setIsError] = useRecoilState(parlorDetailErrorState);
  const [isLoading, setIsLoading] = useState(false);

  const revalidate = useCallback(async () => {
    setIsLoading(true);
    if (parlorId) {
      try {
        const parlor = await get(`/parlors/${parlorId}/price_detail/?sangjo=${type}`);

        setDetail(optimizeParlorDetail(parlor));
        return optimizeParlorDetail(parlor);
      } catch {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    }
  }, [parlorId, type]);

  return {
    parlor: detail,
    setParlor: setDetail,
    isParlorLoading: isLoading,
    isParlorError: isError,
    parlorRevalidate: revalidate,
  };
}

export default useParlorDetail;
